import React from 'react';
import componentProps, { ComponentProps } from '../../../../helpers/componentProps';
import { applyComponentTheme } from '../../../../theme';
import { PanelOptions } from '../../../Panel/PredefinedPanel/predefinedStyles';
import { ContentSpacing, StyledPredefinedPanel } from './styles';

export type ErrorContainerProps = {
  id: string;
  errorText?: string;
  warningText?: string;
  fieldSet?: boolean;
  errorId: string;
  children?: React.ReactNode;
} & ComponentProps;

const ErrorContainer: React.FC<ErrorContainerProps> = ({
  id,
  errorText,
  warningText,
  fieldSet,
  errorId,
  children,
  ...rest
}) => {
  const labelText = errorText || warningText;
  const showPanel = !!labelText;
  const getPanelType = (): PanelOptions => {
    if (errorText) {
      return PanelOptions.ERROR;
    }
    return warningText ? PanelOptions.WARNING : PanelOptions.NONE;
  };

  return (
    <StyledPredefinedPanel
      forwardAs={fieldSet ? 'fieldset' : undefined}
      bottomLabelText={labelText}
      bottomLabelRole="alert"
      bottomLabelAriaLive="assertive"
      bottomLabelId={errorId}
      panelType={getPanelType()}
      cornerLabel={{ icon: errorText ? 'error' : 'warning' }}
      {...componentProps(rest)}
      id={id}>
      <ContentSpacing showPanel={showPanel}>{children}</ContentSpacing>
    </StyledPredefinedPanel>
  );
};

export default applyComponentTheme(ErrorContainer, 'ErrorContainer');
